export const blurAll = () => {
  try {
    (document.activeElement as HTMLElement).blur();
  } catch (error) {
    //
  }
};
